/**
 * Modals
 * 
 * # Structure of js-modal
    <* id="{{Modal.id}}" class="js-modal modal">
        <* class="js-modal-dialog modal-dialog">
            <a href="#" class="modal-dismiss">
                Close
            </*>
            {{Content}}
        </*>
    </*>
 *  
 *
 */

const cssClasses = {
    modal: 'js-modal',
    modalActive: 'modal_active',
    modalDialog: 'js-modal-dialog',
    retainScrolling: 'js-modal-scrollable'
};

class Modal {
    constructor(element) {
        this._element = element;
    }

    dismiss() {
        if(!this._element.classList.contains(cssClasses.retainScrolling)) {
            document.body.style.position = 'static'; // Restore scrolling.
        }
        this._element.classList.remove(cssClasses.modalActive);

        const modalDismissedEvent = document.createEvent('Event');
        modalDismissedEvent.initEvent('modalDismissed', false, false);
        document.dispatchEvent(modalDismissedEvent);
    }

    launch() {
        if(!this._element.classList.contains(cssClasses.retainScrolling)) {
            document.body.style.position = 'fixed'; // Prevent scrolling.
        }
        this._element.classList.add(cssClasses.modalActive);

        const modalLaunchedEvent = document.createEvent('Event');
        modalLaunchedEvent.initEvent('modalLaunched', false, false);
        document.dispatchEvent(modalLaunchedEvent);
    }

    _preventScroll(event) {
        event.preventDefault();
    }
}

export default class Modals {
    constructor() {
        this._modals = new Map();
        this._activeModal = null;
        document.addEventListener('DOMContentLoaded', this._init.bind(this));
    }

    get activeModal() {
        return this._activeModal;
    }
    set activeModal(modal) {
        if (this._activeModal) {
            this._activeModal.dismiss();
        }

        // Modal might be null.
        if (modal) {
            modal.launch();
        }

        this._activeModal = modal;
    }

    get modals() {
        return this._modals;
    }

    _init() {
        const modalElements = document.getElementsByClassName(cssClasses.modal);

        if (!modalElements || !modalElements.length) {
            return;
        }

        for (let i = 0; i < modalElements.length; i++) {
            const modalElement = modalElements[i];
            this.modals.set(`#${modalElement.id}`, new Modal(modalElement));
        }

        this._launchModal(window.location.hash);

        window.addEventListener('hashchange', () => {
            this._launchModal(window.location.hash);
        });
    }

    _launchModal(hash) {
        const modal = this.modals.get(hash);

        if (modal) {
            this.activeModal = modal;
        } else {
            this.activeModal = null;
        }
    }
}
